import { Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

/*
  Styled component implementation. I was not able to figure out how to pass props and resize component
  , therefore wrote following using styled components. Tested once and found it to be working.
  Reverting back to previous implementation and using hacky way (viz. scale) to descrease size of switch.

 const AntSwitch = styled(Switch)`
  width: 58px;
  height: 24px;
  padding: 0px;
  display: flex;
  .MuiSwitch-switchBase {
    padding: 4px;
    color: ${props => props.theme.palette.grey[500]};
    &.Mui-checked {
      transform: translateX(33.5px);
      color: ${props => props.theme.palette.common.white};
      & + .MuiSwitch-track {
        opacity: 1;
        background-color: ${props => props.theme.palette.primary.main};
        border-color: ${props => props.theme.palette.primary.main};
      }
    }
  }

  .MuiSwitch-thumb {
    width: 16px;
    height: 16px;
    box-shadow: none;
  }

  .MuiSwitch-track {
    border: 1px solid ${props => props.theme.palette.grey[500]};
    border-radius: 17px;
    opacity: 1;
    background-color: ${props => props.theme.palette.common.white};
    position: relative;
    &:before, &:after {
      display: inline-block;
      position: absolute;
      top: 50%;
      width: 50%;
      transform: translateY(-50%);
      color: #fff,
      text-align: center
    }
  }

  .MuiSwitch-input {
      left: -172%;
      width: 410%;
  }

  .Mui-checked {
      & + .MuiSwitch-track {
        &:before: {
          opacity: 1;
        }
        &:after: {
          opacity: 0;
        }
      }
    }
`;

 */
const AntSwitch = withStyles((theme) => ({
  root: {
    width: 58,
    height: 24,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 4,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(33.5px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 17,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    '&:before, &:after': {
      display: 'inline-block',
      position: 'absolute',
      top: '50%',
      width: '50%',
      transform: 'translateY(-50%)',
      color: '#fff',
      textAlign: 'center',
    },
    // '&:before': {
    //   content: '"Yes"',
    //   right: 22,
    //   opacity: 0
    // },
    // '&:after': {
    //   content: '"No"',
    //   color: theme.palette.text.secondary,
    //   left: 22
    // }
  },
  input: {
    left: '-172%',
    width: '410%',
  },
  checked: {
    '& + $track': {
      '&:before': {
        opacity: 1,
      },
      '&:after': {
        opacity: 0,
      },
    },
  },
}))(Switch);

export default AntSwitch;
